import * as React from "react";
import { Typeahead } from 'react-bootstrap-typeahead';
import { CustomOption, extactValues } from "../utils/TypeAhead";
import { calcEditDistance } from "../../utils/edit-distance";
import { calcAlignment } from "../../utils/string-alignment";
import { TypeaheadEnterEscWrapper } from "./TypeaheadEnterEscWrapper";

export interface Props
{
    options: string[];
    selected: string[];
    placeholder?: string;
    newSelectionPrefix?: string;

    onChange: (tags: string[]) => void;

    className?: string;
}

export interface State
{
    filteredOptions: string[];
}

// AddTags is a wrapper arround 3d party react-bootstrap-typeahead
// The main feature of this component is that makes fuzzy search according to Levenshtein distance https://en.wikipedia.org/wiki/Levenshtein_distance
export class AddTags extends React.Component<Props, State>
{
    constructor(props)
    {
        super(props);
        this.state = {
            filteredOptions: this.props.options || [],
        };
    }
    
    componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any)
    {
        this.setState({ filteredOptions: nextProps.options });
    }

    render()
    {
        const { selected, onChange, className, placeholder, newSelectionPrefix } = this.props;
        const { filteredOptions } = this.state;

        return (
            <TypeaheadEnterEscWrapper>
                <Typeahead key="add-tags" className={className}
                    placeholder={placeholder}
                    newSelectionPrefix={newSelectionPrefix}
                    allowNew
                    multiple
                    selected={selected || []}
                    options={filteredOptions}
                    filterBy={(option, text) => {
                        return filteredOptions.indexOf(option) >= 0;
                    }}
                    onChange={(opts: CustomOption[]) => onChange(extactValues(opts))}
                    onInputChange={this.handleInputChange.bind(this)}
                    />
            </TypeaheadEnterEscWrapper>
        );
    }

    private handleInputChange(text: string)
    {
        const { options } = this.props;
        if(text == null || text === '') {
            this.setState({ filteredOptions: options });
            return;
        }

        // Get a tag and sort all tags with respect to edit distance
        // Get rid of values which a less than some threshold
        // This threshold is calculated in a hacky way but works well in practice – feel free to play with it
        const source = text.toLocaleLowerCase();
        const evaluate = (tag: string): [string, Score] => [tag, this.getScore(source, tag.toLocaleLowerCase())];
        const items = this.props.options.map(evaluate);
        const filteredOptions = items
            .filter(item => {
                return item[1].value >= 0.5 && item[1].alignment >= Math.floor(Math.log2(item[0].length));
            })
            .sort((a, b) => b[1].value - a[1].value)
            .map(item => item[0]);
        
            this.setState({ filteredOptions });
    }    

    private getScore(source: string, target: string): Score
    {
        const alignment = calcAlignment(source, target);
        const editDistance = calcEditDistance(source, target);
        const value = alignment / Math.sqrt(alignment + editDistance + 1);
        return { alignment, editDistance, value};
    }
}

interface Score
{
    alignment: number;
    editDistance: number;
    value: number;
}


// WEBPACK FOOTER //
// ./src/app/components/AddTags.tsx